import React, { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';
import { PageBar } from '@tencent/spaui';
import { connect } from 'react-redux';
import ArticleSummery from './articleSummery';
import { getArticleBySearch } from '@/api/cgi/knowledge/index';
import actions from '@/app/actions.js';
import { reportUserBehaviorCgi } from '@/api/cgi/common';
class Search extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      value: 1,
      data: [],
      catalog_id: '',
      totalSize: 0,
      page: 1,
      isSearchDone: false,
    };
    this.getSearch = this.getSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    const { knowledge_token = '' } = this.props.accountInfo || {};
    if (knowledge_token) {
      if (nextProps.match.params.keyword !== this.props.match.params.keyword) this.getSearch(nextProps.match.params.keyword);
    }
  }
  componentDidMount() {
    const { knowledge_token = '' } = this.props.accountInfo || {};
    if (knowledge_token) {
      this.getSearch(this.props.match.params.keyword);
    }
  }
  getSearch(keyword) {
    const { knowledge_token } = this.props.accountInfo;
    const { dispatch } = this.props;
    const { page } = this.state;
    if (!keyword) return false;
    const param = {
      behavior: '搜索',
      page1: '知识',
      page2: `知识库-${Date.now()}`,
      page3: '内容中台文章详情',
      relation_type: keyword,
    };
    reportUserBehaviorCgi({ data: param });
    getArticleBySearch({ data: { knowledge_token, keyword, page } }).then((res) => {
      const { data = {}, code } = res;
      if (code == 0) {
        dispatch({
          type: actions.knowledgeTypes.list,
          response: data.list,
        });
        this.setState({
          data: data.list || [],
          totalSize: data.conf.total_num,
          isSearchDone: true,
          keyword,
        });
      }
    });
  }
  handleChange(event, page) {
    this.setState(
      {
        page,
      },
      (_) => {
        this.getSearch(this.props.match.params.keyword);
      },
    );
  }
  toDetail(id, key, title) {
    const params = this.props.match.params[0];
    this.props.history.push(`/list/detail/${params ? params : ''}?id=${id}&source=${encodeURIComponent(`搜索#${encodeURIComponent(this.state.keyword)}`)}`);
  }
  render() {
    const { data, isSearchDone, totalSize, page, keyword } = this.state;
    return (
      <div className="help_detail_container">
        <div className="help_content_main">
          <div className="help_content_topbar">
            <div className="help-content_topbar_left">知识列表</div>
          </div>
          <div className="help_search_page help-all">
            <div className="help_search_page_content">
              {data.length > 0
                && data.map((v, key) => {
                  return <ArticleSummery keyword={keyword} prevPageType="search" articlesummary={v} key={v.post_id} onClick={(e) => this.toDetail(v.post_id, key, v.title)} />;
                })}
              {isSearchDone && data.length == 0 && <span>未找到与“{this.props.match.params.keyword}”相关的答案，请尝试输入其他关键词进行搜索</span>}
            </div>
            <PageBar id="Pagebar" className="help_artical_pagebar" value={page} pageSize={20} totalSize={totalSize} showTotalPage={false} onChange={this.handleChange} />
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
  return {
    accountInfo: state.knowledge.knowledge_info,
    searchVal: state.knowledge.knowledge_search,
    navlist: state.knowledge.knowledge_list,
  };
}
export default withRouter(connect(mapStateToProps)(Search));
